/**
 * Array helper methods
 */
export class ArrayHelper {

    public static ToSingleArray<T>(acc: T[]|undefined, cur: T[]|undefined): T[] {
        if (!acc && !cur) {
            return [];
        }

        if (!cur) {
            return acc!;
        }

        return acc!.concat(cur);
    }

    public static LastValueReducer<T>(acc:T, cur: T): T {
        return cur;
    }

    public static MaxValueReducer(maxValue: number, currentValue: number): number {
        return maxValue <= currentValue ? maxValue : currentValue;
    }

    public static MinValueReducer(minValue: number, currentValue: number): number {
        return minValue >= currentValue ? minValue : currentValue;
    }

    public static ToUniqueValues<T>(acc: T[], cur: T): T[] {
        if (acc.length === 0) {
            return [cur];
        }

        if (acc.indexOf(cur) === -1) {
            acc.push(cur);
        }

        return acc;
    }

    public static ValidResults(item:any): boolean {
        return !!item;
    }

    public static ValidityReducer(acc: boolean, next: boolean): boolean {
        return acc && next;
    }

    /**
     * whatItDoes
     * reduces array of numerical values to highest numerical value set in array
     */
    public static ToHighestValue(acc: number, cur: number): number {
        return acc >= cur ? acc : cur;
    }

    /**
     * whatItDoes
     * reduces array of numerical values to lowest numerical value set in array
     */
    public static ToLowestValue(acc: number, cur: number): number {
        return acc <= cur ? acc : cur;
    }

    /**
     * whatItDoes
     * adds values and returns sum
     */
    public static ToSum(acc: number, next: number): number {
        return acc + next;
    }

    public static flatten<T>(array: any[][]): T[] {
        return array.reduce((acc, arr) => {
            return [...acc, ...arr];
        }, []);
    }

    public static isDefined<T>(arg: T | null | undefined): arg is T extends null | undefined ? never : T {
        return arg !== null && arg !== undefined;
    }
}
